'use strict';

var base = require('core/product/base');
var zonos = require('../zonos');
var Extend = window.Extend;
var siteIntegrations = require('core/integrations/siteIntegrationsUtils');
var toggleObject = siteIntegrations.getIntegrationSettings();
var SiteConstants = require('constants/SiteConstants');
setTimeout(function() {
    $('body').trigger('preload:minicart');
}, 500);
function postCartAddAlert(element) {
    element.on('click', function() {
        $('.add-to-basket-alert').remove();
        $('.modal-background').fadeOut(SiteConstants.TransitionSpeed);
        $('.modal-background').off();
    });
}

function postCartAddTemplate(messageType, message, whichPage) {
    var cartLink = $('.minicart-link').attr('href');
    if(whichPage === 'Cart-Show') {
        return '<div class="alert alert-dismissible user-interaction-alert ' + messageType + ' add-to-basket-alert d-flex align-items-center justify-content-center flex-column text-wrap--balance" role="alert">'
            + '<p class="font-size--32 mb-0 text-wrap--balance">' + message + '</p>'
            + '<button type="button" class="btn close icon-close add-to-basket-close" data-dismiss="alert" aria-label="Close"></button>'
        + '</div>'
    } else {
        return '<div class="alert alert-dismissible user-interaction-alert ' + messageType + ' add-to-basket-alert d-flex align-items-center justify-content-center flex-column text-wrap--balance" role="alert">'
            + '<p class="font-size--32 mb-0 text-wrap--balance">' + message + '</p>'
            + '<a href="'+ cartLink +'" class="d-block btn btn-sm atc-toast-go-to-cart mx-auto my-3 px-1 py-3 w-100 w-md-75 text-wrap--no-wrap add-to-basket-alert-go-to-cart">Go to Cart</a>'
            + '<button type="button" class="d-block btn btn-secondary btn-sm m-auto px-1 py-3 w-100 w-md-75 text-wrap--no-wrap add-to-basket-alert-continue-shopping">Continue Shopping</button>'
            + '<button type="button" class="btn close icon-close add-to-basket-close" data-dismiss="alert" aria-label="Close"></button>'
        + '</div>'
    }

}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    if (response) {
        $('.minicart .popover').empty();
        $('.minicart .popover').append(response);
        $('.minicart-header .close').on('click', event => {
            $('.minicart .popover').removeClass('show');
            $('.minicart-overlay').removeClass('minicart-overlay-hover');
        });
        response = {
            quantityTotal : new Number($('#quantityTotalMiniCart').val()).toFixed(),
            analyticsurl : $('#analyticsurlMiniCart').val(),
            pliUUIDMiniCart : $('#pliUUIDMiniCartMiniCart').val(),

            error : ($('#errorMiniCart').val() === 'true'),
            message : $('#messageMiniCart').val(),
            minicartCountOfItems : $('#minicartCountOfItemsMiniCart').val()
        };
        setTimeout(function () {
            if(response.analyticsurl) {
                fetch(response.analyticsurl);
            }
        }, 2000);
        $('.minicart').trigger('count:update', response);

        var whichPage = $('.page').attr('data-action');
        if(whichPage !== 'Cart-Show' && whichPage !== 'Wishlist-ShowDetail') {
            $('.minicart .popover').addClass('show');
            $('.minicart-overlay').addClass('minicart-overlay-hover');
            zonos.updateZonosPricing();
            $('body').trigger('minicart:loaded', $('.minicart .popover'));
            let element = $('.minicart .popover .product-summary');
            element.animate({
                scrollTop: element[0].scrollHeight
            }, 600);
            return;
        }

        if(whichPage === 'Cart-Show' || whichPage === 'Wishlist-ShowDetail') {
            var messageType = response.error ? 'alert-danger' : '';
            // show add to cart toast
            if ($('.add-to-cart-messages').length === 0) {
                $('body').append(
                    '<div class="add-to-cart-messages"></div>'
                );
            }
            if(whichPage !== 'Wishlist-ShowDetail') {
                $('.modal-background').fadeIn(SiteConstants.TransitionSpeed);
                $('.add-to-cart-messages').append(postCartAddTemplate(messageType, response.message, whichPage));
            }
            // handle hiding the ATC toast, and modal background.
            // also remove click events to prevent multiple stacking up.
            postCartAddAlert($('.add-to-basket-alert-continue-shopping'));
            postCartAddAlert($('.modal-background'));
            postCartAddAlert($('.add-to-basket-close'));


            setTimeout(function () {
                $('.add-to-basket-alert').remove();
                $('.modal-background').fadeOut(SiteConstants.TransitionSpeed);
                $('.modal-background').off();
            }, 3000);
        }
    }
}

/**
 * Updates slider for PDP main images and thumbnails from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createSlider(images, assets, videos, $productContainer) {
    var $sliderContainers = $productContainer.find('.primary-images .slider-container');
    var data = images !== null ? {images} : null;
    data.assets = assets || null;
    data.videos = videos || null;

    // Reversing order in which to update sliders so that thumbnails get initialized first
    $($sliderContainers.get().reverse()).each((index, sliderContainer) => {
        var $slider = $(sliderContainer).find('.slider');
        $slider.trigger('slider:update', data);
    });
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer, currentTarget) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVariant;
    var isSetItem = $productContainer.hasClass('product-set-item-detail') ? true : false;

    if (response.product.variationAttributes) {
        this.updateAttrs(response.product.variationAttributes, $productContainer, response.resources, currentTarget);
        isVariant = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVariant) {
            $productContainer.parent('.bonus-product-item').data('pid', response.product.id);
            $productContainer.parent('.bonus-product-item').data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    var primaryImages = response.product.images;
    var pdpGalleryAssets = response.product.pdpGalleryAssets;
    var vimeoVideos = response.vimeoVideos;
    var exclusionData = response.product.exclusionData;
    var $oldWishlistIcon = $productContainer.find('.primary-images-main .wishlist-toggle-product').clone(true);

    this.createSlider(primaryImages, pdpGalleryAssets, vimeoVideos, $productContainer);
    // if variant is a product set item, update the sample image
    if (isSetItem) {
        $productContainer
            .find('.product-set-item-main-image')
            .attr('src', primaryImages.large[0].url)
            .attr('alt', primaryImages.large[0].alt);
    }

    // Update Product Name and Description
    var productName = response.product.productName;
    var headline = response.product.headlineDescription;

    if (productName) {
        $productContainer.find('.product-name').empty().html(productName);
    }

    // Handle description
    if (response.product.attrsToUseForSwatch.length > 0) {

        if (response.product.readyToOrder) {
            if (headline) {
                $productContainer.find('.product-description-below-product-name span').empty().html(headline);
                base.methods.checkDescriptionHeight();
            }

            // Update the product 'sku' number
            var productNumber = response.product.id.includes('_') ? response.product.id.split('_')[1] : response.product.id;
            $productContainer.find('.master-product-id').text(productNumber);
        } else {
            $productContainer.find('.master-product-id').empty();
            $productContainer.find('.product-description-below-product-name span').empty();
            base.methods.checkDescriptionHeight();
        }
    } else {
        if (headline) {
            $productContainer.find('.product-description-below-product-name span').empty().html(headline);
            checkDescriptionHeight();
        }
    }

    // Update pricing
    var $priceSelector = $('.prices .price', $productContainer).length
        ? $('.prices .price', $productContainer)
        : $('.prices .price');

    if (!isChoiceOfBonusProducts && response.product.readyToOrder) {
        $priceSelector.replaceWith(response.product.price.html);
    } else{
        $priceSelector.replaceWith('<div class="price price-message warn-hilite">'+ response.resources.selectForPricing + '</div>');
    }


    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    this.updateAvailabilityProcess(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty().html(this.getAttributesHtml(response.product.attributes));

    // Update wishlist
    if ($oldWishlistIcon && $oldWishlistIcon.length) {
        var $newWishlistIcon = $oldWishlistIcon;
        $newWishlistIcon.attr('data-wishlistpid', response.product.wishlistpid);
        $newWishlistIcon.attr('data-addmessage', response.product.wishlistMessages.addTitle);
        $newWishlistIcon.attr('data-removemessage', response.product.wishlistMessages.removeTitle);

        //Make heart icon accurate
        var wishlist = require('core/wishlist/components/helpers.js');
        wishlist.updateLinkData($newWishlistIcon);

        $productContainer.find('div.primary-images-main .wishlist-toggle-product').replaceWith($newWishlistIcon);
    }

    // Update Exclusion Message
    var hidePdpExclusionMessage = $productContainer.find('input[name="hidePdpExclusionMessage"]').val();
    if (!hidePdpExclusionMessage && exclusionData.ExcludedFromDiscounts && exclusionData.ExclusionMessage && exclusionData.ExclusionMessage.length > 1) {
        $('#exclusionMessage').empty().html(exclusionData.ExclusionMessage);
    }

    zonos.updateZonosPricing();
}

/**********
 * shared across QV and PDP
 */
function addToCart () {
    var scope = this;

    // if qty stepper input has focus, we need to blur it so product data can update before button click
    $(document).on('mouseenter', 'button.add-to-cart, button.add-to-cart-global', function (event) {
        var $button = $(event.target);
        var $container = $button.closest('.product-detail');
        if (!$container.length) {
            $container = $button.closest('.quick-view-dialog');
        }
        var $qtyStepperInput = $container.find('.quantity-stepper input');

        if ($qtyStepperInput.length && $qtyStepperInput.is(':focus')) {
            $qtyStepperInput.blur();
        }
    });

    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function (event) {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;
        var quantity;

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            var $products = $(this).closest('.product-detail').find('.product-set-item-detail');
            if (!$products.length) {
                if ($(this).closest('.quick-view-dialog').length) {
                    $products = $(this).closest('.quick-view-dialog').find('.product-set-item-detail');
                } else {
                    $products = $('.product-detail');  // pagedesigner component 'Add all to cart btn' won't have .product-set-item-detail classes
                }
            }

            $products.each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: scope.methods.getOptions($(this))
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = scope.methods.getPidValue($(this));

        quantity = $(this).hasClass('single-variant-quick-add-to-cart') ? 1 : scope.methods.getQuantitySelected($(this));

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            if ($(this).hasClass('single-variant-quick-add-to-cart')) {
                addToCartUrl = $(this).data('url');
            } else {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
                var $productModalbody = $(this).closest('.modal-content');
                addToCartUrl = scope.methods.getAddToCartUrl($productModalbody);
            }
        } else {
            addToCartUrl = scope.methods.getAddToCartUrl($productContainer);
        }

        // Start RS customization - Complete the Look (Pendant Chain recommendations)
        var $completeTheLookContainer = $(this).closest('.product-detail').find('.js-complete-the-look');
        if ($completeTheLookContainer.length > 0) {
            setPids = [{
                pid: pid,
                qty: quantity
            }];
            $completeTheLookContainer.each((_index, container) => {
                var $container = $(container);
                var $selectedRadios = $container.find('input[type="radio"]:checked');
                $selectedRadios.each((_index, radio) => {
                    var addonPid = $(radio).data('pid');
                    var addonQty = scope.methods.getQuantitySelected($(this));
                    if (addonPid && addonQty) {
                        setPids.push({
                            pid: addonPid,
                            qty: addonQty
                        });
                    }
                });
            });
            pidsObj = JSON.stringify(setPids);
        }
        // End RS customization - Complete the Look (Pendant Chain recommendations)

        // Begins RS Customization - Personalization
        var personalizationDetails = {
            groups: {}
        };

        $('.js-customization-input').each(function() {
            var input = $(this);
            var groupName = input.data('input-group');
            if (!personalizationDetails.groups[groupName]) {
                personalizationDetails.groups[groupName] = {
                    inputs: {},
                    style: null
                };
            }
            personalizationDetails.groups[groupName].inputs[input.attr('name')] = {
                value: input.val(),
                lineItemLabel: input.data('line-item-label')
            };
        });

        $('.js-style-select:checked').each(function() {
            var selectedStyle = $(this);
            var groupName = selectedStyle.data('input-group');
            if (personalizationDetails.groups[groupName]) {
                personalizationDetails.groups[groupName].style = selectedStyle.val();
                personalizationDetails.groups[groupName].styleLabel = selectedStyle.attr('data-style-label');
            }
        });
        // End RS Customization - Personalization

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: scope.methods.getChildProducts(),
            quantity: quantity,
            options: scope.methods.getOptions($productContainer),
            customizations: JSON.stringify(personalizationDetails) // RS Personalization
        };

        // BEGIN Extend integration
        var EXT_PDP_UPSELL_SWITCH = window.EXT_PDP_UPSELL_SWITCH || undefined;
        var isPlanSelected = false;
        form.area = 'product_page';
        form.component = 'buttons';
        const price = $('#extend-offer').data('price') * 100;
        const category = $('#extend-offer').data('category');

        if ($('#extend-offer').length) {
            var extendComponent = window.Extend.buttons.instance('#extend-offer');
            if (extendComponent != null) {
                var extendPlan = extendComponent.getPlanSelection();

                if (extendPlan) {
                    form.extendPlanId = extendPlan.planId;
                    form.extendPrice = extendPlan.price;
                    form.extendTerm = extendPlan.term;
                    form.price = price;
                    form.category = category;
                    isPlanSelected = true;
                    $(this).trigger('updateAddToCartFormData', form);
                }
            }
            if (EXT_PDP_UPSELL_SWITCH && !isPlanSelected) {
                $('body').trigger('extend:modal:viewed',
                    { productId: form.pid, area: 'product_modal' });

                Extend.modal.open({
                    referenceId: $('.product-detail').data('pid').replace(/_/g, ' '),
                    category: category,
                    onClose: function (plan) {
                        if (plan) {
                            form.extendPlanId = plan.planId;
                            form.extendPrice = plan.price;
                            form.extendTerm = plan.term;
                            form.area = 'product_modal';
                            form.price = price;
                            form.category = category;
                            form.component = 'modal';
                            $(this).trigger('updateAddToCartFormData', form);
                        }

                    if (addToCartUrl) {
                        $.ajax({
                            url: addToCartUrl,
                            method: 'POST',
                            data: form,
                            success: function (data) {
                                handlePostCartAdd(data);
                                $('body').trigger('product:afterAddToCart', data);
                                $('body').trigger('personalization:afterSuccess');
                                $.spinner().stop();
                            },
                            error: function () {
                                $.spinner().stop();
                            }
                        });
                    }
                }
            });
            return;
        }
    }
        // END Extend integration

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    scope.methods.handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    $('body').trigger('product:afterAddToCartQuickview', data); //cart page quickview only
                    $('body').trigger('personalization:afterSuccess');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

function handleCompleteTheLookRadios() {
    var $completeTheLookContainer = $('.js-complete-the-look');
    if ($completeTheLookContainer.length > 0) {
        $completeTheLookContainer.each((_index, container) => {
            var $container = $(container);
            var $radios = $container.find('input[type="radio"]');
            $radios.on('change', _event => {
                var $selectedRadios = $radios.filter(':checked:not([id^="none"])');
                var $noneRadio = $radios.filter('[id^="none"]').closest('.custom-radio');
                if ($selectedRadios.length > 0) {
                    $noneRadio.removeClass('d-none');
                }
            });
        });
    }
}
// START RS Customization: PDP Custom Variant Dropdown
function getLongestStringLengthByColumnType($cells) {
    var maxCharLength = 0;

    $cells.each(function() {
        var charLength = 0;
        if ($(this).data('cell-type') === 'price') {
            charLength = parseInt($(this).find('.value').text().trim().length, 10);
        } else {
            charLength = parseInt($(this).text().trim().length, 10);
        }
        if (charLength > maxCharLength) {
            maxCharLength = charLength;
        }
    });

    return maxCharLength;
}
function handleCustomSelectPicker() {
    $(document).on('click', ".custom-select-picker .dropdown-item", function () {
        var isCurrentSelection =  $(this).attr("data-selected");
        if (isCurrentSelection !== "true") {
            var value = $(this).data("value");
            var originalSelectId = $(this)
                .closest(".custom-select-picker")
                .attr("data-controls");
            var $originalSelectNode = $("#" + originalSelectId);

            // Update the button label to the selected option's display value
            var $dropdownButton = $(this)
                .closest(".custom-select-picker")
                .find(".dropdown-toggle");
            var $dropdownButtonLabel = $dropdownButton.find('.dropdown-toggle-label');
            var buttonHtml = $(this).html();
            $dropdownButtonLabel.html(buttonHtml);

            $originalSelectNode.find("option").each(function () {
                if ($(this).data("attr-value") === value) {
                    $(this).prop("selected", true);
                    $dropdownButtonLabel.css('grid-template-columns', $dropdownButtonLabel.data('grid-column-sizes'));
                } else {
                    $(this).prop("selected", false);
                }
            });

            // Update the original select node (hidden in DOM)
            var $productContainer = $(this).closest('.product-detail');
            var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
            if (isChoiceOfBonusProducts) {
                var currentTarget = $(this).parents('.attribute').find('select[class*="select-"], .options-select').find('option[data-attr-value="'+$(this).data('attr-value')+'"]');
                base.methods.attributeSelect(currentTarget.val(), $productContainer, currentTarget);
            } else {
                $originalSelectNode.trigger("change");
            }

            // Update data-selected for dropdown-items
            var $dropdownMenu = $(this).closest('.dropdown-menu');
            $dropdownMenu.find('.dropdown-item').each(function () {
                $(this).data('selected', false).attr('data-selected', 'false');
            });
            $(this).data('selected', true).attr('data-selected', 'true');
        }
    });

    // Initial setup
    $(".custom-select-picker").each(function () {
        var $dropdownButton = $(this).find(".dropdown-toggle");
        var $dropdownButtonLabel = $dropdownButton.find('.dropdown-toggle-label');
        var $selectedItem = $(this).find(
            '.dropdown-item[data-selected="true"]'
        );
        var buttonHtml;
        var buttonCss;

        // Generate colummn sizes
        var $dropdownDisplayNameCells = $(".custom-select-picker").find('.js-custom-select-displayname');
        var $dropdownPriceCells = $(".custom-select-picker").find('.js-custom-select-price');
        var $dropdownAvailabilityCells = $(".custom-select-picker").find('.js-custom-select-availability');
        var maxDisplayNameLength = getLongestStringLengthByColumnType($dropdownDisplayNameCells);
        var maxPriceLength = getLongestStringLengthByColumnType($dropdownPriceCells);
        var maxAvailabilityLength = getLongestStringLengthByColumnType($dropdownAvailabilityCells);

        var dropdownWidth = `${maxDisplayNameLength + maxPriceLength + maxAvailabilityLength}ch`
        $('.custom-select-picker').css('width', dropdownWidth);
        $('.custom-select-picker .dropdown-item:not(.reset)').css('grid-template-columns', `${maxDisplayNameLength}fr ${maxPriceLength}fr ${maxAvailabilityLength}fr`);
        $('.custom-select-picker .dropdown-toggle-label').data('grid-column-sizes', `${maxDisplayNameLength}fr ${maxPriceLength}fr ${maxAvailabilityLength}fr`);

        // Check if there is a preselected item
        if ($selectedItem.length) {
            buttonHtml = $selectedItem.html();
            buttonCss = $selectedItem.css('grid-template-columns');
        } else {
            // Fallback to the first item if no preselected item found
            buttonHtml = $(this).find(".dropdown-item:first").html();
        }

        // Update the dropdown button label
        $dropdownButtonLabel.html(buttonHtml);
        $dropdownButtonLabel.css('grid-template-columns', buttonCss);
    });
}

function onQuickViewOpen() {
    $(document).on('quickview:ready', function() {
        handleCustomSelectPicker();
    })
}
// END RS Customization: PDP Custom Variant Dropdown

// RS Customization: PDP Custom Variant Radios in leu of OOTB SFRA Dropdown
function handleCustomRadioPicker() {
    $('body').on('click', '.js-radio-vip-select input[type="radio"]', function() {
        var selectedValueId = $(this).data('value-id');
        var optionId = $(this).prop('name');
        var $parentNodeSelect = $('div[data-attr="'+optionId+'"] .custom-select');
        if ($parentNodeSelect) {
            $parentNodeSelect.val($parentNodeSelect.find('option[data-attr-value="' + selectedValueId + '"]').val());
            $parentNodeSelect.change();
        }
    });
}
// END RS Customization: PDP Custom Variant Radios in leu of OOTB SFRA Dropdown

// RS Customization: PDP Radio Button Product Option Select
function handleRadioOptions() {
    $('body').on('change', '.js-radio-options-select input[type="radio"]', function() {
        var selectedValueId = $(this).data('value-id');
        var optionId = $(this).prop('name');
        var $parentNodeSelect = $('div[data-option-id="'+optionId+'"] .options-select');
        if ($parentNodeSelect) {
            $parentNodeSelect.val($parentNodeSelect.find('option[data-value-id="' + selectedValueId + '"]').val());
            $parentNodeSelect.change();
        }
    })
}
// END RS Customization: PDP Radio Button Product Option Select

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    var methods = this;

    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <div class="modal-title m-auto">' + data.labels.selectprods + '</div>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = methods.parseHtml(response.renderedTemplate);
            var count = 0;
            $('#chooseBonusProductModal .modal-header .modal-title').text(response.promoTitle);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body).prepend(`<div class="col-12">${response.promoDescription}</div>`);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');

            // LBH update - auto-select first variant for each bonus product
            $('#chooseBonusProductModal .product-detail').each((_index, element) => {
                var $productContainer = $(element);
                count++;
                var $variantSelect = $productContainer.find('.attribute select');
                if (!$variantSelect.find('option:selected').data('attr-value')) {
                    $variantSelect.val($variantSelect.find('option[data-attr-value]').first().val());
                    $variantSelect.trigger('change');
                }
            });

            if (count < 2) {
                $('#chooseBonusProductModal').addClass('narrow').find('.bonus-product-item').removeClass('col-6').addClass('col-12');
            }

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

function selectBonusProduct() {
    $(document).on('click', '.select-bonus-product', function () {
        var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
        var pid = $(this).data('pid');
        var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
        var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
        var totalQty = 0;
        $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
            totalQty += $(this).data('qty');
        });
        totalQty += submittedQty;
        var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
        var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
        if (totalQty > 0) {
            $('.add-bonus-products').removeClass('disabled'); //if a bonus product is selected make sure to enable the atc button
        }
        if (totalQty <= maxPids) {
            var selectedBonusProductHtml = ''
            + '<div class="selected-pid" '
            + 'data-pid="' + pid + '"'
            + 'data-qty="' + submittedQty + '"'
            + 'data-optionID="' + (optionID || '') + '"'
            + 'data-option-selected-value="' + (valueId || '') + '"'
            + '>'
            + '<div class="bonus-product-name">'
            + $choiceOfBonusProduct.find('.product-name').html()
            + '</div>'
            + '<div class="remove-bonus-product"></div>'
            + '</div>'
            ;
            $('#chooseBonusProductModal .selected-bonus-products .bonus-summary-products-container').append(selectedBonusProductHtml);
            $('.pre-cart-products').html(totalQty);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            $('body').trigger('modal:loaded', $('#chooseBonusProductModal')); // update quickview modal scroll height
        } else {
            $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
        }

        // LBH update - trigger add to cart when only eligible for one bonus product
        if (totalQty === 1) {
            $('#chooseBonusProductModal .add-bonus-products').trigger('click');
        }
    });
}

function updateAddToCart() {
    $('body').on('product:updateAddToCart', function (e, response) {
        var $productContainer = response.$productContainer;
        // update local add to cart (for sets)
        $productContainer.find('button.add-to-cart').attr('disabled',
            (!response.product.readyToOrder || !response.product.available));
        if (response.product.readyToOrder && response.product.available) {
            var btnStringOrderable = $productContainer.find('button.add-to-cart').data('text-orderable');
            $productContainer.find('button.add-to-cart').html(btnStringOrderable);
            $productContainer.find('.quantity-stepper').removeClass('disabled');
        }
        // update global add to cart (single products, bundles)
        var $dialog = $(response.$productContainer).closest('.quick-view-dialog');

        // LBH Customization - on Wish List page we use quickWishlistUpdate (quickAddToCart but with the wishlist update button and the 'quick-update-wishlist' added)
        // therefore, run the else clause for wishlist updates
        if ($dialog.length && !$dialog.find('.quick-update-wishlist')){
            $dialog.find('.add-to-cart-global, .update-cart-product-global').attr('disabled',
                !$dialog.find('.global-availability').data('ready-to-order')
                || !$dialog.find('.global-availability').data('available')
            );
            console.log(!$dialog.find('.global-availability').data('ready-to-order')
            || !$dialog.find('.global-availability').data('available'));
        } else {
            var enable = $productContainer.find('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $productContainer.find('button.add-to-cart-global, button.btn-update-wishlist').attr('disabled', !enable);
        }
    });
}


function onRecommenderSliderReady() {
    $(document).on('targetslider:ready', function(event, object) {
        var closestParent = $('#' + object.id).closest('.recommender-row');

        if (closestParent.length > 0) {
            var $preloaderNode = closestParent.find('.targetslider-loading-container');
            var $renderedNode = closestParent.find('.targetslider-container');
            $preloaderNode.fadeOut(300, function() {
                $renderedNode.removeClass('d-none').fadeIn(300);
            });
        }
    });

    // Set a timeout to check if the skeleton is still visible after 5 seconds
    window.onload = function() {
        // Set a timeout to check if the skeleton is still visible after 10 seconds
        setTimeout(function() {
            $('.recommender-row').each(function() {
                var $container = $(this);
                var $preloaderNode = $container.find('.targetslider-loading-container');

                // If the preloader is still visible, hide the container
                if ($preloaderNode.is(':visible')) {
                    $container.fadeOut(300);
                }
            });
            zonos.updateZonosPricing();
        }, 10000); // 10 seconds timeout
    };
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer, msgs, currentTarget) {
    var viewOutOfStockItems = window.CachedData.siteIntegrations.viewOutOfStockItems;
    var $attr = '.custom-select[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + '.select-' + $.escapeSelector(attr.id) + ' option:first-child');
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;

    $defaultOption.attr('value', attr.resetUrl).attr('disabled', true);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url).removeAttr('disabled');
        var currentSelectedOption = $(currentTarget).find('option:selected');

        if (!viewOutOfStockItems && (!attrValue.selectable || !attrValue.available)) {
            if (!attrValue.selectable) {
                $attrValue.attr('disabled', true);
            }
            //check if selected value is now unavailable, if so select the default option
            if (currentSelectedOption.data('attr-value') == attrValue.value) {
                $attrValue.removeAttr('selected');
                $($attr).prop('selectedIndex', 0);
            }
            // append a msg to option to tell user its not available with selected options
            $attrValue.html(attrValue.displayValue + msgs.unavailableMsg);
        } else {
           $attrValue.html(attrValue.displayValue);
            if (currentSelectedOption.text() == attrValue.displayValue) {
                if (isChoiceOfBonusProducts) {
                    $productContainer.find('a.dropdown-item[data-attr-value="'+currentSelectedOption.data('attr-value')+'"]').attr('data-selected',true);
                    var $dropdownButtonLabel = $productContainer.find(".custom-select-picker").find(".dropdown-toggle").find('.dropdown-toggle-label');
                    var buttonHtml = $productContainer.find('a.dropdown-item[data-attr-value="'+currentSelectedOption.data('attr-value')+'"]').html();
                    $dropdownButtonLabel.html(buttonHtml);
                }
                $(currentSelectedOption).attr('selected', 'selected');
                $productContainer.find($attr).prop('selectedIndex', $(currentSelectedOption).index());
            }
        }
        $attrValue[attrValue.available ? 'addClass' : 'removeClass']('available');
        $attrValue.removeClass('unavailable out-of-stock');

        if (!attrValue.available) {
            $attrValue.addClass(toggleObject.viewOutOfStockItems ? 'out-of-stock' : 'unavailable');
            $attrValue.append(' ' + msgs.unavailableMsg);
        }
    });
}

function updateQuantityStepperDisabledStates($stepper) {
    var min = parseInt($stepper.attr('data-min'));
    var max = parseInt($stepper.attr('data-max'));
    var $input = $stepper.find('input');
    var $minusButton = $stepper.find('[data-action="decrease"]');
    var $plusButton = $stepper.find('[data-action="increase"]');
    var value = !isNaN(parseInt($input.prop('data-qty'))) ? parseInt($input.prop('data-qty')) : parseInt($input.attr('data-qty'));
    var cartLineItem = $stepper.closest('.base-line-item');
    var upsellLineItem = $stepper.closest('.upsell-line-item');
    var miniCartLineItem = $stepper.closest('.minicart-item');

    if (value <= min) {

        // LBH Customization: if qty stepper is on cart page, do NOT disable.
        if (cartLineItem.length || miniCartLineItem.length || upsellLineItem.length) {
            $minusButton.removeClass('icon-minus').addClass('icon-delete');
        }else {
            $minusButton.addClass('disabled');
        }
    } else {
        if (cartLineItem.length || miniCartLineItem.length || upsellLineItem.length) {
            $minusButton.removeClass('icon-delete').addClass('icon-minus');
        }else{
            $minusButton.removeClass('disabled');
        }
    }

    if (value >= max) {
        $plusButton.addClass('disabled');
    } else {
        $plusButton.removeClass('disabled');
    }
}

function bindQuantityStepperButtons($stepper) {
    var methods = base.methods;
    var $select = $stepper.prev('select');
    var min = parseInt($stepper.data('min'));
    var max = parseInt($stepper.data('max'));
    var cartLineItem = $stepper.closest('.base-line-item');
    var upsellLineItem = $stepper.closest('.upsell-line-item');
    var miniCartLineItem = $stepper.parents('.minicart-item');

    $stepper.find('button').off('click').click(event => {
        event.preventDefault();
        var $button = $(event.target);
        var action = $button.data('action');
        var previousValue = parseInt($stepper.find('input').val());
        var newValue = previousValue;

        if (action === 'increase' && (previousValue + 1 <= max)) {
            newValue++;
        }
        if (action === 'decrease' && (previousValue - 1 >= min)) {
                newValue--;
        } else if ((cartLineItem.length || miniCartLineItem.length || upsellLineItem.length) && (action === 'decrease' && (previousValue == min))) {
            var removeBtn;
            if (cartLineItem.length) {
                removeBtn = cartLineItem.find('.primary-edit .remove-product')
            } else if (miniCartLineItem.length) {
                removeBtn = miniCartLineItem.find('.remove-product')
            } else if (upsellLineItem.length) {
                removeBtn = upsellLineItem.find('.remove-product');
            }
            if (removeBtn) {
                removeBtn.trigger('stepper:removeProduct');
            }
        }

        if (newValue !== previousValue) {
            $select.find('option[value="' + newValue + '"]').prop('selected', true).change();
            $stepper.find('input').prop('value', newValue).prop('data-qty', newValue);
            methods.updateQuantityStepperDisabledStates($stepper);
            $('body').trigger('quantityStepper:change', $stepper);
        }
    });
}

function addBonusProductsToCart() {
    $(document).on('click', '.add-bonus-products', function () {
        var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
        var queryString = '?pids=';
        var url = $('.choose-bonus-product-dialog').data('addtocarturl');
        var pidsObject = {
            bonusProducts: []
        };

        $.each($readyToOrderBonusProducts, function () {
            var qtyOption =
                parseInt($(this)
                    .data('qty'), 10);

            var option = null;
            if (qtyOption > 0) {
                if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                    option = {};
                    option.optionId = $(this).data('optionid');
                    option.productId = $(this).data('pid');
                    option.selectedValueId = $(this).data('option-selected-value');
                }
                pidsObject.bonusProducts.push({
                    pid: $(this).data('pid'),
                    qty: qtyOption,
                    options: [option]
                });
                pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
            }
        });
        queryString += JSON.stringify(pidsObject);
        queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
        queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
        $.spinner().start();
        $.ajax({
            url: url + queryString,
            method: 'POST',
            success: function (data) {
                $.spinner().stop();
                if (data.error) {
                    $('#chooseBonusProductModal').modal('hide');
                    $('.modal-background').fadeIn(SiteConstants.TransitionSpeed);
                    if ($('.add-to-cart-messages').length === 0) {
                        $('body').append('<div class="add-to-cart-messages"></div>');
                    }
                    $('.add-to-cart-messages').append(
                        '<div class="alert user-interaction-alert alert-dismissible add-to-basket-alert text-center"'
                        + ' role="alert">'
                        + data.errorMessage + '<button type="button" class="btn close icon-close add-to-basket-close" data-dismiss="alert" aria-label="Close"></button></div>'
                    );

                    $('.modal-background').on('click', function() {
                        $('.add-to-basket-alert').remove();
                        $('.modal-background').fadeOut(SiteConstants.TransitionSpeed);
                        $('.modal-background').off();
                    });

                    $('.add-to-basket-close').on('click', function(){
                        $('.add-to-basket-alert').remove();
                        $('.modal-background').fadeOut(SiteConstants.TransitionSpeed);
                        $('.add-to-basket-close').off();
                    });
                    setTimeout(function () {
                        $('.modal-background').fadeOut(SiteConstants.TransitionSpeed);
                        $('.add-to-basket-close').off();
                        $('.add-to-basket-alert').remove();
                    }, 3000);
                } else {
                    $('.configure-bonus-product-attributes').html(data);
                    $('.bonus-products-step2').removeClass('hidden-xl-down');
                    $('#chooseBonusProductModal').modal('hide');
                    $('.modal-background').fadeIn(SiteConstants.TransitionSpeed);
                    if ($('.add-to-cart-messages').length === 0) {
                        $('body').append('<div class="add-to-cart-messages"></div>');
                    }
                    $('.minicart-quantity').html(data.totalQty);
                    $('.add-to-cart-messages').append(
                        '<div class="alert alert-dismissible user-interaction-alert add-to-basket-alert text-center"'
                        + ' role="alert">'
                        + data.msgSuccess + '<button type="button" class="btn close icon-close add-to-basket-close" data-dismiss="alert" aria-label="Close"></button></div>'
                    );

                    $('.modal-background').on('click', function() {
                        $('.add-to-basket-alert').remove();
                        $('.modal-background').fadeOut(SiteConstants.TransitionSpeed);
                        $('.modal-background').off();
                    });

                    $('.add-to-basket-close').on('click', function(){
                        $('.add-to-basket-alert').remove();
                        $('.modal-background').fadeOut(SiteConstants.TransitionSpeed);
                        $('.add-to-basket-close').off();
                    });

                    sessionStorage?.setItem?.('cartcount', data.totalQty);

                    setTimeout(function () {
                        $('.add-to-basket-alert').remove();
                        $('.modal-background').fadeOut(SiteConstants.TransitionSpeed);
                        $('.add-to-basket-close').off();
                        if ($('.cart-page').length) {
                            location.reload();
                        }
                    }, 1500);
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
}

function nonColorAttribute() {
    $(document).on('click', '.attribute button.swatch', function(e) {

        e.preventDefault();

        if ($(this).find('.unselectable').length) {
            return;
        }

        var $productContainer;

        if ($('.product-bundle').length) {
            $productContainer = $('.bundle-main-product').length ? $(this).closest('.bundle-main-product') : $(this).closest('.product-bundle');
        } else {
            $productContainer = $(this).closest('.set-item');
        }

        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail');
        }

        var swatches = [];
        if ($('body') && $('body').length > 0) {
            var attributes = $('body').find('.attribute');
            $.each(attributes, function () {
                var disSwatch = $(this).find('.swatch');
                if (disSwatch.length == 1) {
                    var firstswatch = $(disSwatch[0]);
                    // If the single swatch is already preselected do not add it to the list to be selected (i.e. going straight to a variation's pdp)
                    if (!firstswatch.find('span.selectable').hasClass('selected')) {
                        swatches.push(firstswatch);
                    }
                    //If we want to hide the attribute selection completely when there is only one choice
                    //disSwatch.parents('.attribute').addClass('visually-hidden');
                }
            });
        }

        //base.methods.attributeSelect($(this).attr('data-url'), $productContainer);

        base.methods.attributeSelect($(this).attr('data-url'), $productContainer, function() {
            base.methods.selectSwatch(swatches);
        });
    });
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer, currentTarget) {
    var methods = this;

    //alert('attributeSelect selectedValueUrl: ' + selectedValueUrl);

    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
        })
            .then((data) => {
                //console.log('attributeSelect data: ', data);
                methods.handleVariantResponse(data, $productContainer, currentTarget);
                methods.updateOptions(data.product.optionsHtml, $productContainer);
                methods.updateQuantities(data.product.quantities, $productContainer);
                methods.updateAttributeContent(data, $productContainer);

                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
            })
            .always(() => $.spinner().stop());
    }
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs, currentTarget) {
    var methods = base.methods;

    //Get the available swatchable attribute array ['color','size'] (currently defined as a site pref, and added as a data attribute to the product container element
    var attrsWithSwatches = $productContainer.data('swatchable-attributes');

    attrs.forEach(function (attr) {
        if (attrsWithSwatches && attrsWithSwatches.indexOf(attr.attributeId) > -1) {
            methods.processSwatchValues(attr, $productContainer, msgs);

            // Update attr selected text based on attr.selected
            var $attrTitle = $productContainer.find('[data-attr="' + attr.attributeId + '"]').find('.non-color-display-value');
            var selectedTitle = attr.selected ? attr.displayValue : msgs.pleaseSelectMsg + ' ' + attr.displayName;

            $attrTitle.text(selectedTitle);

            if (!attr.selected) {
                $attrTitle.addClass('warn-hilite');
            } else {
                $attrTitle.removeClass('warn-hilite');
            }

        } else {
            methods.processNonSwatchValues(attr, $productContainer, msgs, currentTarget);
        }
    });
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    if (attr.attributeId == 'color') {
        $productContainer.find('.color-display-value').text(attr.displayValue || '');
    };

    if (attr.attributeId == 'size') {
        $productContainer.find('[data-attr="size"]').find('.non-color-display-value').text(attr.displayValue || '');
    };

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');

        var $swatchButton = $attrValue.parent('button');

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
            $attrValue.attr('selected', 'selected');
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
            $attrValue.removeAttr('selected');
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable available unavailable out-of-stock');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
        $attrValue.addClass(attrValue.available ? 'available' :  toggleObject.viewOutOfStockItems ? 'out-of-stock' : 'unavailable');

        // LBH Update button title
        var titleText = attrValue.available ? '' : attrValue.selectable ? msgs.swatchUnavailable : msgs.swatchSoldOut;
        $attrValue.attr('title', titleText);

        $attrValue.attr('value', attrValue.url).removeAttr('disabled');
        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Fetch html updates for variation -- SFCC struggles to parse waincludes
 * LBH - extend this to also update any PDP keyword content
 * partially implemented while we transition PDP Keyword-based content from Page
 * Designer assets to content assets
 *
 * @param {Object} data the data from attributeSelect ajax call
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateAttributeContent (data, $productContainer) {
    console.log('updateAttributeContent triggered data: ', data);
    if (data && data.product && ((data.product.collapsibleContent != '') || (data.product.tabs != ''))) {
        var processInclude = require('base/util');
        // This list should include any JS files that check for specific nodes in DOM that may be added to tabs/collapsible content
        var reinitFiles = require('core/utilities/ajaxHelpers').getReinitFiles();

        console.log('get new HTML content for variation')

        $.ajax({
            url: data.product.variationHtmlUrl,
            method: 'GET',
            dataType: 'html'
        })
            .then((html) => {
                // console.log('updateAttributeContent html: ', html);
                // update the product container with the new html
                const $html = $(html);
                const $collapseHtml = $html.find('.main-content-item');
                const $tabHtml = $html.find('.tabs');

                $productContainer.find('.main-content-item')[$collapseHtml.length ? 'replaceWith' : 'hide']($collapseHtml);
                $productContainer.find('.tabs')[$tabHtml.length ? 'replaceWith' : 'hide']($tabHtml);
            })
            .then(() => {
                // reset the collapsible content
                if ($productContainer.find('.main-content-item').length) {
                    $('body').trigger('product:afterAttributeContentSwap', { container: $productContainer.find('.main-content-item') });
                }
            })
            .then(() => {
                Object.keys(reinitFiles).forEach(function (key) {
                    if (typeof reinitFiles[key] == 'object') return;

                    if (key === 'slider') {
                        ['.main-content-item', '.tabs'].forEach(function (section) {
                            let productSection = $productContainer.find(section);
                            if (productSection.length) {
                                reinitFiles[key].initializeSliders(productSection);
                            }
                        })
                    } else {
                        processInclude(reinitFiles[key]);
                    }
                });
            })
            .then(() => {
                // reinit video events
                ['.main-content-item', '.tabs'].forEach(function (section) {
                    let productSection = $productContainer.find(section);
                    if (productSection.length) {
                        let sliderSection = $productContainer.find(section + ' .slider-container');
                        if (sliderSection.length) {
                            $('body').trigger('ajax:load.ajaxEvents', [sliderSection]);
                        }
                        $('body').trigger('ajax:load.ajaxEvents', [productSection]);
                    }
                })
            });
    }
}

/**
 * checkDescriptionHeight
 *
 * For swatchable products only (ex: diamond dtud earrings)
 * Check the height of the product description and add a class if it exceeds 2 line heights
 * The class enables a "read more" link to be displayed by measuring the height of the text
 * and comparing it to 2 line heights. If it exceeds 2 line heights, the class is added
 *
 * @returns {void}
 */
function checkDescriptionHeight() {
    var $productDescriptionText = $('.swatchable-product #product-description-main');
    $productDescriptionText.removeClass('over-2lh');
    $productDescriptionText.closest('.description-container').removeClass('over-2lh');

    var descHeight = $productDescriptionText.outerHeight();

    var computedH = 2 * parseFloat($productDescriptionText.css('line-height'));
    var isOver = descHeight > computedH;
    //console.log('isOver', descHeight, computedH);
    if (isOver) {
        $productDescriptionText.addClass('over-2lh');
        $productDescriptionText.closest('.description-container').addClass('over-2lh');
    } else {
        $productDescriptionText.removeClass('over-2lh');
        $productDescriptionText.closest('.description-container').removeClass('over-2lh');
    }

}

base.methods.createSlider = createSlider;
base.methods.handleVariantResponse = handleVariantResponse;
base.methods.handlePostCartAdd = handlePostCartAdd;
base.methods.chooseBonusProducts = chooseBonusProducts;
base.methods.processNonSwatchValues= processNonSwatchValues;
base.methods.updateQuantityStepperDisabledStates = updateQuantityStepperDisabledStates;
base.methods.bindQuantityStepperButtons = bindQuantityStepperButtons;
base.addToCart = addToCart;
base.handleCompleteTheLookRadios = handleCompleteTheLookRadios;
base.handleCustomSelectPicker = handleCustomSelectPicker;
base.handleRadioOptions = handleRadioOptions;
base.selectBonusProduct = selectBonusProduct;
base.handleCustomRadioPicker = handleCustomRadioPicker;
base.onClosingChooseBonusProductModal = null; // removes toast warning when no bonus products are selected
base.onQuickViewOpen = onQuickViewOpen;
base.onRecommenderSliderReady = onRecommenderSliderReady;
base.updateAddToCart = updateAddToCart;
base.addBonusProductsToCart = addBonusProductsToCart;
base.methods.updateAttrs = updateAttrs;
base.methods.processSwatchValues = processSwatchValues;
base.methods.attributeSelect = attributeSelect;
//base.methods.updateAttributeContent = updateAttributeContent;
base.nonColorAttribute = nonColorAttribute;
base.methods.checkDescriptionHeight = checkDescriptionHeight;

$(document).ready(function() {
    checkDescriptionHeight();
});

module.exports = base;
